import { SaveOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import SaveFilterData from "./SaveFilterData";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";

const SaveFilterDataButton = () => {
  const { filter } = useSelector((state: RootState) => state.realState);
  const [isShowSaveModal, setIsShowSaveModal] = useState(false);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  return (
    <>
      <MazakaButton
        icon={<SaveOutlined />}
        onClick={() => {
          if(!userInfoes)
          {
            openNotificationWithIcon("default","Filtreyi kaydetmek için giriş yapınız")
          }
          else{

            setIsShowSaveModal(true);
          }
        }}
        className="!bg-[#FFC502] !text-black !text-xs !w-full lg:!max-w-[200px]"
      >
        Filtreyi Kaydet
      </MazakaButton>
      <Modal
        open={isShowSaveModal}
        onCancel={() => {
          setIsShowSaveModal(false);
        }}
        title={false}
        footer={false}
      >
        <SaveFilterData
          onFinish={() => {
            setIsShowSaveModal(false);
          }}
        />
      </Modal>
    </>
  );
};

export default SaveFilterDataButton;
